import { OnTerminalLog, Serial } from './serial'
import i18n from 'i18next'
import { sendATCommand } from './command'
import { sleep } from '@/pages/utils/sleep'

const MODEM_BOOT_MAX_ATTEMPTS = 30
const MODEM_BOOT_TIMEOUT_MS = 500

export const ensureModemReady = async (
  session: Serial,
  onTerminalLog: OnTerminalLog,
): Promise<void> => {
  onTerminalLog(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.logs.checkingModemAfterReconnect',
    ),
  )
  for (let attempt = 0; attempt < MODEM_BOOT_MAX_ATTEMPTS; attempt += 1) {
    onTerminalLog(
      i18n.t(
        'device.calibration.preFlightStep.certificateUploadFlow.logs.atProbe',
        {
          attempt: attempt + 1,
          totalAttempts: MODEM_BOOT_MAX_ATTEMPTS,
          phaseLabel: i18n.t(
            'device.calibration.preFlightStep.certificateUploadFlow.logs.phaseAfterReconnect',
          ),
        },
      ),
    )
    const response = await session.sendCommand('AT')
    if (response.includes('OK')) {
      onTerminalLog(
        i18n.t(
          'device.calibration.preFlightStep.certificateUploadFlow.logs.modemRespondsAfterReconnect',
        ),
      )
      onTerminalLog(
        i18n.t(
          'device.calibration.preFlightStep.certificateUploadFlow.logs.configuringModem',
        ),
      )
      for (const command of ['ATE1', 'AT+IFC=2,2']) {
        await sendATCommand(session, command, ['OK'])
      }
      return
    }
    await sleep(MODEM_BOOT_TIMEOUT_MS)
  }

  throw new Error(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.errors.modemNotReadyAfterReconnect',
    ),
  )
}

export const checkModemAfterStore = async (
  session: Serial,
  onTerminalLog: OnTerminalLog,
): Promise<void> => {
  onTerminalLog(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.logs.checkingModemAfterStore',
    ),
  )
  await sendATCommand(session, 'AT', ['OK'])
}
